import { createStore } from 'zustand/vanilla';

import { type DeviceType, type Repub } from '@cx-modules/types';

import {
	type FooterV2Response,
	type NavV2Response,
} from '~/interfaces/HeaderFooterNavV2';

export interface LayoutState {
	deviceType: DeviceType;
	footerData: FooterV2Response;
	navData: NavV2Response;
	repub: Repub;
	resourcesUrl: string;
}

export type LayoutStore = LayoutState;

export const defaultInitialState: LayoutState = {
	resourcesUrl: '',
	deviceType: 'DESKTOP',
	repub: 'US',

	/**
	 * This cast here is fine since we only render the navData if
	 * `isInitialized` has been set
	 */
	navData: {} as NavV2Response,
	footerData: {} as FooterV2Response,
};

export const createLayoutStore = (
	initState: LayoutState = defaultInitialState,
) => {
	return createStore<LayoutStore>()(() => ({
		...initState,
	}));
};
